import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Grid, Dialog, DialogContent } from "@mui/material";
import {useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import PageLoader from "../commoncomponents/PageLoader";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import CustomDialog from "../commoncomponents/CustomDialog";
import Axios from 'axios';
import commonMessages from "../../utility/constant";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import PageTitle from "../commoncomponents/PageTitle";
import { MasterGraph, FemsGraph, BemsGraph, ifacSecurityURL } from "../../utility/apiURLS";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import { getAuthToken, getcompanyId, getFacilityId } from "../../utility/tokenUtility";
import Ppmcalenderdownload from './Ppmcalenderdownload';

const PpmCalendarTable = () => {
    const navigate = useNavigate();
    const accessData = useAccess();
    const [loading, setLoading] = useState(false);
    const access = utilities.getScreenPermissions(accessData, "ENGA009A");
    const all = { label: "All", value: "All", id: null }
    const facilityid = getFacilityId("");
    const [service, setService] = useState("");
    const [workgroup, setWorkgroup] = useState("");
    const [selectedHospital, setSelectedHospital] = useState(null);
    const [selectedService, setSelectedService] = useState(null);
    const [workgroupOptions, setWorkgroupOptions] = useState([]);
    const [pageLoading, setPageLoading] = useState(false)
    const [year, setYear] = useState(null);
    const currentYear = new Date().getFullYear();
    const [monthsOptions, setMonthsOptions] = useState([all]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [departmentcode, setDepartmentcode] = useState(null);
    const [month, setMonth] = useState();
    const [serviceOptions, setServiceOptions] = useState();
    const [hospitalname, setHospitalname] = useState("");
    const [reportdata, setReportdata] = useState([]);
    const [errors, setErrors] = useState({});
    const [errorMessages, setErrorMessages] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [hospitalnameOptions, setHospitalnameOptions] = useState([]);
    const token = getAuthToken("id_token");
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const dispatch = useDispatch();
    const [isView, setIsView] = useState(false);
    const childRef = useRef(null);
    const userId = localStorage.getItem('UserId');
    const companyId = getcompanyId("companyId");
    const allMonths = commonMessages.months1;

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const handleServiceChange = (newValue) => {
        if (newValue) {
            setService(newValue);
            setErrors((prevErrors) => ({ ...prevErrors, service: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, service: "" }));
            setSelectedService(newValue);
            setWorkgroup(null);
            setErrors((prevErrors) => ({ ...prevErrors, workgroup: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, workgroup: "" }));
        } else {

            setService(null);
            setSelectedService(null);
            setErrors((prevErrors) => ({ ...prevErrors, service: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, service: "Service is required." }));


            setWorkgroup(null);
            setErrors((prevErrors) => ({ ...prevErrors, workgroup: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, workgroup: "" }));
        }
    };

    const handlehospital = (newValue) => {
        console.log("Selected hospital:", newValue);
        if (newValue) {
            setHospitalname(newValue);
            setErrors((prevErrors) => ({ ...prevErrors, hospitalname: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, hospitalname: "" }));
            setSelectedHospital(newValue);
            fetchWorkGroupDetails(newValue);  // Ensure this fetches the correct data
            fetchDepartmentcode(newValue);
        }
    };
    useEffect(() => {
        console.log("selectedHospital changed:", selectedHospital);
    }, [selectedHospital]);
    
    const handleDepartmentCodeChange = (selectedOption) => {
        setDepartmentcode(selectedOption || "");
        console.log("Deparmtent",selectedOption);
        if (selectedOption) {
            setErrors((prevErrors) => ({ ...prevErrors, service: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, service: "" }));
        }
    };

    const handleYearChange = (newValue) => {
        if (newValue) {
            if (newValue.value !== year?.value) {
                setYear(newValue);
    
                const selectedYear = parseInt(newValue.value, 10);
    
                // Update months to always show January to December
                const updatedMonths = [...allMonths]; // Always show all months
    
                setMonthsOptions([{ label: "All", value: "All" }, ...updatedMonths]); // Prepend "All" option
                setMonth(null); // Reset the selected month
                setErrors((prevErrors) => ({ ...prevErrors, year: false })); // Clear errors for year
                setErrorMessages((prevMessages) => ({ ...prevMessages, year: "" })); // Clear error messages for year
            }
        }
    };
    
    const handleMonthChange = (newValue) => {
        setMonth(newValue);
        setErrors((prevErrors) => ({ ...prevErrors, month: false }));
        setErrorMessages((prevMessages) => ({ ...prevMessages, month: "" }));
    };
    
    const yearsOptions = Array.from(
        { length: currentYear - 2016 + 1 },
        (_, i) => ({
            label: (2016 + i).toString(),
            value: (2016 + i).toString(),
        })
    );
    
    useEffect(() => {
        // Initialize the default year and months
        setYear({ label: currentYear.toString(), value: currentYear.toString() });
        setMonthsOptions([{ label: "All", value: "All" }, ...allMonths]); // Show all months by default
    }, []);
    
    const handleCancel = () => {
        if (!hospitalnameOptions) {
            navigate("/dashboard");
            dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
            dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
        } else {
            setCancelDialogOpen(true);
        }

    };


    const handleWorkgroup = (selectedOption) => {
        setWorkgroup(selectedOption || null);
        setErrors((prevErrors) => ({ ...prevErrors, workgroup: false }));
        setErrorMessages((prevMessages) => ({ ...prevMessages, workgroup: "" }));
    };

    const fetchHospitalName = async () => {
        try {
            const response = await Axios.get(`${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyId}/${userId}`, config);

            if (response.data && Array.isArray(response.data)) {
                const options = response?.data?.map((hn) => ({
                    label: hn.facilityName,
                    id: hn.facilityId,
                }));
                setHospitalnameOptions(options);
            }
        } catch (error) {
            console.error("Error fetching hospital names:", error);
        }
    };
    const fetchServiceOptions = async () => {
        try {
            const response = await Axios.get(`${MasterGraph}/api/masservicedetails`, config);
            const filteredOptions = response?.data?.filter(option => option?.service);
            setServiceOptions(filteredOptions?.map(option => ({
                label: option?.service,
                value: option?.service,
                id: option.id
            })));

            // Option to add "All" as a dropdown option
            // const allOption = { value: 0, label: 'All' };

            // Set the options by combining "All" with the filtered options
            setServiceOptions([...filteredOptions?.map(option => ({
                label: option.service,
                value: option.service,
                id: option.id
            }))]);

        } catch (error) {
            console.error("Error fetching service options:", error);
        }
    };

    const fetchDepartmentcode = async (service, selectedHospital) => {
        try {
            let response;
    
            if (service === "FEMS") {
                response = await Axios.get(
                    `${FemsGraph}/api/UserLocationCode/GetDepartmentcodeppmcalendar/${selectedHospital?.id}?page=1&&size=2000`,
                    config
                );
            } else if (service === "BEMS") {
                response = await Axios.get(
                    `${BemsGraph}/api/UserLocationCode/GetDepartmentcodeppmcalendar/${selectedHospital?.id}?page=1&&size=2000`,
                    config
                );
            }
    
            const items = response?.data || [];
            const filteredOptions = items?.map((op) => ({
                label: `${op?.departmentcode} - ${op?.departmentdesc}`,
                value: op?.departmentcode,
                id: op?.id,
            }));
    
            console.log("Filtered Options:", filteredOptions);
            setDepartmentOptions(filteredOptions);
        } catch (error) {
            console.error("Error fetching department options:", error);
        }
    };
    
    const fetchWorkGroupDetails = async (service, Selectedhospital) => {
        try {
            if (!Selectedhospital || !selectedHospital?.id) {
                console.error("Selectedhospital is invalid or missing.");
                return [];
            }
    
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
    
            const allOption = { label: "All", value: "All", id: null };
    
            if (service === "FEMS") {
                const response = await Axios.get(
                    `${FemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${Selectedhospital?.id}?size=10000`,
                    config
                );
                console.log(response, "responsefems");
                return [
                    allOption,
                    ...response?.data?.map((item) => ({
                        label: `${item?.wgcode} - ${item?.wgdesc}`,
                        value: item?.wgcode,
                        id: item?.id,
                    })),
                ];
            } else if (service === "BEMS") {
                const response = await Axios.get(
                    `${BemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${Selectedhospital?.id}?size=10000`,
                    config
                );
                console.log(response, "responsebems");
                return [
                    allOption,
                    ...response?.data?.map((item) => ({
                        label: `${item?.wgcode} - ${item?.wgdesc}`,
                        value: item?.wgcode,
                        id: item?.id,
                    })),
                ];
            }
        } catch (error) {
            console.error("Error fetching workgroup details:", error);
            return [];
        }
    };
    
  

    useEffect(() => {
        const loadWorkgroupOptions = async () => {
            if (!service?.value) {
                console.warn("Service is not defined or invalid.");
                return;
            }
    
            if (!selectedHospital?.id) {
                console.error("Selected hospital is missing or invalid.");
                setWorkgroupOptions([]); 
                setDepartmentOptions([]);// Default to empty array
                return;
            }
    
            try {
                const options = await fetchWorkGroupDetails(service?.value, selectedHospital);
                setWorkgroupOptions(options || []);
                const option = await fetchDepartmentcode(service?.value, selectedHospital);
                
                setDepartmentcode(option ||[]);// Default to empty array if no options
            } catch (error) {
                console.error("Error loading workgroup options:", error);
                setWorkgroupOptions([]); 
                setDepartmentOptions([]);// Default to empty array on error
            }
        };
    
        loadWorkgroupOptions();
    }, [service?.value, selectedHospital?.id]); // Updated dependencies// Ensure selectedHospital is included as a dependency

    const postReport = async () => {
        setPageLoading(true);
        const facilityid = getFacilityId("facilityId");
        const companyId = getcompanyId("companyId");
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const payload = {
                workgroupdetailsId: workgroup?.id,
                facilityId: selectedHospital?.id,
                serviceId: service?.id,
                year: year?.label,
                month: month?.id,
                userdepartmentId: departmentcode?.id || null,
                ppmScheduleReportListVMs: [],
            };

            const checkService = service.value === "FEMS" ? FemsGraph : BemsGraph;

            const response = await Axios.post(`${checkService}/api/PPMScheduleReport/PPMScheduleReportList`, payload, config);

            const reportdata = response?.data;
            setReportdata(reportdata);
            return reportdata;
        } catch (error) {
            console.error("Error posting department:", error);
        }
        finally {
            setPageLoading(false);
        }

    };
    useEffect(() => {
        if (selectedHospital) {
            fetchWorkGroupDetails(selectedHospital);
        }
    }, [selectedHospital]);

    useEffect(() => {
        fetchHospitalName();
        fetchServiceOptions();
        fetchWorkGroupDetails();
     
    }, []);
    useEffect((service) =>
    {
        fetchDepartmentcode(service);
    },[service])

    const handleView = async () => {
        setIsView(true);
        if (!service || !month || !hospitalname || !workgroup) {
            setErrors({
                hospitalname: !hospitalname,
                service: !service,
                month: !month,
                workgroup: !workgroup,

            });
            setErrorMessages({
                hospitalname: !hospitalname ? "Hospital Name is required" : "",
                service: !service ? "Service is required" : "",
                month: !month ? "Month is required" : "",
                workgroup: !workgroup ? "Work Group Code is required" : ""
            });
            return;

        }
        try {
            const response = await postReport();
            if (response) {
                setOpenModal(true);
            }
        } catch (error) {
            console.log("Error during report fetch:", error);
        }
    };

    const handleCancelConfirm = () => {
        setCancelDialogOpen(false);
        navigate("/dashboard");
        dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
        dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
    };
    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };

    return (
        <>
            <PageLoader open={pageLoading} />
            <PageTitle title={"PPM Calendar Report"} />

            <Box mt={{ xs: 1, sm: 2 }}>
                <DefaultCard>
                    <Grid container spacing={2}>

                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Hospital Name"
                                id="hospital-name"
                                value={hospitalname || null}
                                options={hospitalnameOptions}
                                onChange={handlehospital}
                                isMandatoryField={true}
                                error={errors.hospitalname}
                                errorMessage={errorMessages.hospitalname}
                            />

                        </Grid>

                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                id="service-label"
                                label="Service"
                                value={service}
                                options={serviceOptions}
                                onChange={handleServiceChange}
                                isMandatoryField={true}
                                error={errors.service}
                                errorMessage={errorMessages.service}
                            />

                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Work Group Code"
                                id="WorkgroupCode"
                                value={workgroup || null}
                                options={workgroupOptions}
                                onChange={handleWorkgroup}
                                isMandatoryField={true}
                                error={errors.workgroup}
                                errorMessage={errorMessages.workgroup}
                            />
                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Year"
                                name="Year"
                                options={yearsOptions}
                                value={year}
                                isMandatoryField={true}
                                onChange={handleYearChange}
                                placeholder={"Select Year"}
                                disableClearable={true}
                            />
                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Month"
                                name="Month"
                                isMandatoryField={true}
                                options={monthsOptions}
                                value={month}
                                onChange={handleMonthChange}
                                placeholder={"Select Month"}
                                error={errors.month}
                                errorMessage={errorMessages.month}
                                disabled={!year}
                            />
                        </Grid>

                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Department Name"
                                value={departmentcode || ""}
                                options={departmentOptions || []}
                                onChange={handleDepartmentCodeChange}
                                error={errors.departmentcode}
                                errorMessage={errorMessages.departmentcode}
                            />
                        </Grid>
                    </Grid>
                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "end" },
                            mt: 3,
                        }}
                    >
                        <Button variant='contained' onClick={handleView}>View</Button>

                        <Button variant='outlined' onClick={handleCancel}>Close</Button>
                    </Box>
                </DefaultCard>
                <Dialog
                    open={openModal}
                    maxWidth="xl"
                    fullWidth
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        ...(!isView && {
                            "& .MuiBackdrop-root": {
                                backgroundColor: "transparent",
                            },
                            top: "-9999px",
                            left: "-9999px",
                            zIndex: "-1",
                        })
                    }}
                >

                    <DialogContent>

                        <Ppmcalenderdownload
                            setOpenModal={setOpenModal}
                            hospitalname={hospitalname}
                            year={year}
                            month={month}
                            service={service}
                            workgroup={workgroup?.value}
                            ref={childRef}
                            reportdata={reportdata}
                        />

                    </DialogContent>
                </Dialog>
            </Box>
            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                onConfirm={handleCancelConfirm}
                title="Cancel Confirmation"
                content="Do you want to continue?"
                cancelBtn="No"
                confirmBtn="Yes"
            />
        </>
    );
};

export default PpmCalendarTable;
